<div class="driver-exercise-card">
  <div class="top-card">
    <div style="display: flex; flex-direction: column; align-items: flex-start;" class="left-card" (click)="goToExercise()">
      <div style="display: flex; gap: 12px;">
        <div class="icon">
          <mat-icon>event</mat-icon>
        </div>
        <div class="text">
          <div class="title">
            {{ exercise().title }}
            <mat-icon style="color: #2d3872">chevron_right</mat-icon>
          </div>
          <div class="subtitle">{{ exercise().dates }}</div>
        </div>
      </div>
      <div class="phase-info">
        @if (exercise().continuous_phase) {
        <div class="phase-badge">Fase continua</div>
        } @else if (exercise().initial_petition) {
        <div class="phase-badge">Petición inicial</div>
        }
      </div>
    </div>
    <div class="right-card">
      <app-vacation-switch
        [exerciseId]="exercise().id"
        [exerciseActive]="exercise().active"
        (statusChanged)="onStatusChanged()"
      ></app-vacation-switch>
    </div>
  </div>
  <!-- <mat-divider></mat-divider>

  <div class="bottom-card">
    <div class="bottom-information">
      <div class="phase-info">
        @if (exercise().continuous_phase) {
        <div class="phase-badge">Fase continua</div>
        } @else if (exercise().initial_petition) {
        <div class="phase-badge">Petición inicial</div>
        }
      </div>
  </div> -->